import React from "react";
import "./WebFormSubmission.scss";

import {
  getWebformConfirmation,
  getWebformSubmission,
  resetWebform,
} from "../services/funds.service";
import { fetcher } from "../helpers/global";
import { useAppContext } from "../hooks/useAppContext";

const WebFormSubmission = () => {
  const { webformToken, setWebformToken } = useAppContext();
  const [isDeleting, setIsDeleting] = React.useState(false);

  const deleteSubmission = (e) => {
    const el = e.target.closest(".webform-submission-delete-link");
    if (el && e.currentTarget.contains(el)) {
      e.preventDefault();
      setIsDeleting(true);
      const webformSubmission = getWebformSubmission();
      const headers = {
        accept: "application/json",
      };
      const url = `webform_rest/webform_id/submission/${webformSubmission}/${webformToken}`;
      fetcher("delete", url, null, headers, null).then(() => {
        resetWebform();
        setWebformToken(null);
        setIsDeleting(false);
      });
    }
  };
  return (
    <div
      onClick={deleteSubmission}
      className={`order-webform-submission${
        (isDeleting && " spinner--after spinner--centered content-blurred") ||
        ""
      }`}
      dangerouslySetInnerHTML={{ __html: getWebformConfirmation() }}
    />
  );
};

export default WebFormSubmission;
